import Render from '@Views/root/accounting/book/aside-book.html'
import { Component, Vue } from 'vue-property-decorator'

@Render
@Component({})
export class ASideBook extends Vue {}